import React from 'react';
import PropTypes from 'prop-types';

import EducationIcons from '../../../atoms/education/icons/educationIcons';
import StyledEducationContentType from './educationContentType.style';

const EducationContentType = ({ contentType }) => {
  if (contentType && contentType.length === 1) {
    return (
      <StyledEducationContentType>
        <EducationIcons icon={contentType[0].slug} />
        <span className="contentType__title">{contentType[0].title}</span>
      </StyledEducationContentType>
    );
  }
  return null;
};

EducationContentType.propTypes = {
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired
};

export default EducationContentType;
